import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserCheckRoster = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解6：名单核对
          </Title>
          <div className="text-lg">
            <p>一、点击队伍管理→操作，出现菜单列表：</p>
            <div className="my-4">
              <Image src="/manual/check_roster/1.png" alt="" />
            </div>
            <p>1、重新编号</p>
            <div className="my-4">
              <Image src="/manual/check_roster/2.png" alt="" />
            </div>
            <p>起始：定义编号的起始号。</p>
            <p>后缀：定义每个编号后面的后缀名。</p>
            <p>是否打乱：定义编号时是否把录入的队伍顺序打乱后重新排序。</p>
            <p>按东西南北分：定义编号时是否按东西、南北的方向区分队伍。 （仅在米切尔复式赛中使用，其余比赛请勿使用）</p>
            <p>2、一键签到： 对所有队伍进行一键签到。</p>
            <p>3、一键取消签到：对所有队伍进行一键取消签到。</p>
            <p>4、一键配对：对所有单个选手进行自动配对。需配对的选手必须已 完成签到。</p>
            <p>二、点击队伍后面的编辑，可修改选手信息。</p>
            <div className="my-4">
              <Image src="/manual/check_roster/3.png" alt="" />
            </div>
            <p>是否弃权：弃权的队伍不参与编排；若已完成编排，则该队伍会在其所在桌次上记灰。弃权的队伍按弃权记分。若需参赛，设为不弃权即 可。</p>
            <p>是否签到：未签到的队伍不参与编排，若需参赛，设为签到即可。参与排名：设为不参与排名的队伍，则该队伍不参加比赛排名。</p>
            <p>其他选项与选手录入中的介绍相同。</p>
            <p>三、点击队伍后面的删除，会删除该队伍在本场赛事中的所有信息。</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserCheckRoster as any, {
  title: '核对参赛名单 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统名单核对:队伍重新编号、编号前后缀、打乱顺序、签到状态等队伍管理操作说明。',
})

export default UserCheckRoster
